import React from 'react';

interface ToolOverlayProps {
  title: string;
  onClose: () => void;
  onExpand: () => void;
  isExpanded?: boolean;
}

const ToolOverlay: React.FC<ToolOverlayProps & { children?: React.ReactNode }> = ({
  title,
  onClose,
  onExpand,
  isExpanded = false,
  children,
}) => {
  return (
    <div className="absolute inset-0 flex flex-col rounded-xl overflow-hidden shadow-lg border border-[#3A3A3C] transition-transform duration-300 ease-in-out bg-[#2D3239]">
      <div className="flex items-center justify-between px-4 py-3 border-[#3A3A3C]">
        <h3 className="text-white font-medium">{title}</h3>
        <div className="flex items-center space-x-2">
          {/* <button 
            onClick={onExpand}
            className="text-gray-400 hover:text-white p-1 transition-colors duration-200"
            aria-label={isExpanded ? "Collapse" : "Expand"}
            title={isExpanded ? "Collapse" : "Expand"}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="transition-transform duration-200">
              {isExpanded ? (
                <>
                  <polyline points="4 14 10 14 10 20"></polyline>
                  <polyline points="20 10 14 10 14 4"></polyline>
                  <line x1="14" y1="10" x2="21" y2="3"></line>
                  <line x1="3" y1="21" x2="10" y2="14"></line>
                </>
              ) : (
                <>
                  <polyline points="15 3 21 3 21 9"></polyline>
                  <polyline points="9 21 3 21 3 15"></polyline>
                  <line x1="21" y1="3" x2="14" y2="10"></line>
                  <line x1="3" y1="21" x2="10" y2="14"></line>
                </>
              )}
            </svg>
          </button> */}
          <button 
            onClick={onClose}
            className="text-gray-400 hover:text-white p-1 transition-colors duration-200 bg-[#1D2126] rounded-full"
            aria-label="Close"
            title="Close"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>
      </div>
      <div className="flex-1 overflow-auto transition-all duration-300">
        {children || (
          <div className="flex items-center justify-center h-full text-gray-400">
            {title} content goes here
          </div>
        )}
      </div>
    </div>
  );
};

export default ToolOverlay;